export const params = ['promo', 'aap'];

export function handler(value, urlSearchParams) {
    import('../autoapplypromo/savepromosfromparams.js').then(({ default: savePromosFromParams }) => savePromosFromParams(value, urlSearchParams));
}

